import { component_tool } from '@/tool'
const { WizLocationSelect } = component_tool
import { WizTableForm } from '../../common'
const trainCenterConfig = WizTableForm.Config.trainCenter()

//配置项
let componentName = 'trainSite'
const columns = (data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '场地名称',
      name: 'name',
      searchItem: {},
      tableItem: {},
      formItem: {}
    },
    {
      title: '场地编号',
      name: 'code',
      searchItem: {},
      tableItem: {},
      formItem: {}
    },
    {
      title: '场地应用类型',
      name: 'type',
      dict: [
        { code: 0, codeName: '教室' },
        { code: 1, codeName: '大门' },
        { code: 2, codeName: '餐厅' },
        { code: 3, codeName: '其他' }
      ],
      tableItem: {},
      formItem: {
        type: 'select'
      }
    },
    {
      title: '培训中心',
      name: 'trainCenterName',
      tableItem: {},
      formItem: {}
    },
    {
      title: '培训中心',
      name: 'trainCenterId',
      searchItem: {
        type: 'diy',
        selectType: 'radio',
        diy: WizTableForm,
        ...trainCenterConfig
      }
    },
    {
      title: '城市',
      name: 'city',
      dataIndex: 'city',
      searchItem: {
        type: 'diy',
        diy: WizLocationSelect,
        showSearch: true,
        optionType: 'city'
      },
      tableItem: {},
      formItem: {}
    },
    {
      title: '地址',
      name: 'address',
      formItem: {}
    },
    {
      title: '场地状态',
      name: 'status',
      dict: [
        { code: 0, codeName: '正常' },
        { code: 1, codeName: '停止使用' },
        { code: 2, codeName: '维修中' }
      ],
      tableItem: {},
      formItem: {
        type: 'select'
      }
    },
    {
      title: '审核类型',
      name: 'auditType',
      dict: [
        { code: 0, codeName: '自动审核' },
        { code: 1, codeName: '手动审核' }
      ],
      tableItem: {},
      formItem: {
        type: 'select'
      }
    },
    {
      title: '场地面积',
      name: 'floorSpace',
      tableItem: {},
      formItem: {}
    },
    {
      title: '进车数量',
      name: 'parkingSpace',
      tableItem: {},
      formItem: {}
    }
  ]
}

const templateConfig = (data) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(data),
        searchBarProps: {
          buttonSort: [],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['reservation', 'look'],
        rowOperateView: [
          {
            key: 'reservation',
            custom: true,
            params: { children: '预约'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/site/trainSite/appointment/management/appointmentAdd'
              }
            }
          }
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/appointmentList`,
    payload: {
      key: `${componentName}@appointmentList`,
      apiParams: {
        status: 0,
        type: 0,
        allowOrder: 0,
        managerType: 2,
        dataPerms_sceneTypeIdList: [125],
        permType: 1
      }
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
